import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from "pages/NotFound";
import Settings from './pages/settings';
import IntegrationsPage from './pages/integrations';
import BillingPage from './pages/billing';
import DealsPage from './pages/deals';
import ContactsPage from './pages/contacts';
import LoginPage from './pages/login';
import SignupPage from './pages/signup';
import EmailsPage from './pages/emails';
import AccountsPage from './pages/accounts';
import Dashboard from './pages/dashboard';
import Pipeline from './pages/pipeline';
import Reports from './pages/reports';
import Activities from './pages/activities';
import LeadsPage from './pages/leads';
import JobsPage from './pages/jobs';
import DispatchPage from './pages/dispatch';
import CalendarPage from './pages/calendar';
import TasksPage from './pages/tasks';
import TemplatesPage from './pages/templates';
import TrashPage from './pages/trash';
import AIVoicePage from './pages/ai-voice';
import AIMarketingPage from './pages/ai-marketing';
import AskAIFloatingButton from './pages/dashboard/components/AskAIFloatingButton';
import OnboardingPage from './pages/onboarding';
import Documentation from './pages/documentation';
import ContactSupport from './pages/contact-support';
import WebsiteBuilder from './pages/website-builder';
import SuperAdminPage from './pages/super-admin';
import PaywallPage from './pages/paywall';
import ReviewRequests from './pages/review-requests';
import AcceptInvitePage from './pages/accept-invite';
import AuthCallback from './pages/auth-callback';
import { useAuth } from './contexts/AuthContext';

const AuthenticatedAIButton = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading || !isAuthenticated) return null;
  return (
    <>
      <AskAIFloatingButton />
    </>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <ScrollToTop />
          <RouterRoutes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
            <Route path="/paywall" element={<ProtectedRoute><PaywallPage /></ProtectedRoute>} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
            <Route path="/jobs" element={<ProtectedRoute><JobsPage /></ProtectedRoute>} />
            <Route path="/dispatch" element={<ProtectedRoute><DispatchPage /></ProtectedRoute>} />
            <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
            <Route path="/templates" element={<ProtectedRoute><TemplatesPage /></ProtectedRoute>} />
            <Route path="/trash" element={<ProtectedRoute><TrashPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/integrations" element={<ProtectedRoute><IntegrationsPage /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
            <Route path="/deals" element={<ProtectedRoute><DealsPage /></ProtectedRoute>} />
            <Route path="/contacts" element={<ProtectedRoute><ContactsPage /></ProtectedRoute>} />
            <Route path="/emails" element={<ProtectedRoute><EmailsPage /></ProtectedRoute>} />
            <Route path="/accounts" element={<ProtectedRoute><AccountsPage /></ProtectedRoute>} />
            <Route path="/pipeline" element={<ProtectedRoute><Pipeline /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/activities" element={<ProtectedRoute><Activities /></ProtectedRoute>} />
            <Route path="/ai-voice" element={<ProtectedRoute><AIVoicePage /></ProtectedRoute>} />
            <Route path="/ai-marketing" element={<ProtectedRoute><AIMarketingPage /></ProtectedRoute>} />
            <Route path="/documentation" element={<ProtectedRoute><Documentation /></ProtectedRoute>} />
            <Route path="/contact-support" element={<ProtectedRoute><ContactSupport /></ProtectedRoute>} />
            <Route path="/website-builder" element={<ProtectedRoute><WebsiteBuilder /></ProtectedRoute>} />
            <Route path="/super-admin" element={<ProtectedRoute requireAdmin={true}><SuperAdminPage /></ProtectedRoute>} />
            <Route path="/review-requests" element={<ProtectedRoute><ReviewRequests /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
          <AuthenticatedAIButton />
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
